/* eslint-disable quote-props */
import {
  BeginSignRequest,
  EndSignRequest,
  SignResult,
  SignVerifyRequest,
  SignVerifyResult
} from '../utils/types';

export const signVerify = (
  requestBody: SignVerifyRequest
): Promise<SignVerifyResult> => {
  return fetch('/registration/signature-declaration/sign/verify', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  });
};

const readJsonContent = async (response: Response) => {
  try {
    if (
      response.headers.get('content-type') === 'application/json' &&
      response.headers.get('content-length') > 0
    ) {
      return await response.json();
    } else {
      console.error('Response content-type is not JSON or length is 0');
      return null;
    }
  } catch (error) {
    console.error('Cannot parse response body as JSON');
    return null;
  }
};

const newSignResult = async (response: Response): Promise<SignResult> => {
  return await readJsonContent(response);
};

export const beginSign = (
  requestBody: BeginSignRequest
): Promise<SignResult> => {
  return fetch('/registration/signature-declaration/sign/begin', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  }).then(newSignResult);
};

export const endSign = (requestBody: EndSignRequest) => {
  return fetch('/registration/signature-declaration/sign/end', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  }).then(newSignResult);
};
